import { DBRow } from '@cloudio-saas/datasource-types';
import { StateXGetter } from '@cloudio-saas/statex';
import { IoWfInstances, UserData } from '@cloudio-saas/workflow-nodes';
import { UserSession } from 'root/useUser';
import { getStore } from 'store/useDataStore';
import { isEmpty } from 'utils/isEmpty';

export function getInstance(get: StateXGetter, appUid: string) {
  const store = getStore<IoWfInstances>({
    appUid,
    pageId: '$$Sidebar$$',
    ds: 'IoWfInstances',
    alias: 'IoWfInstances-viewer',
  });
  const id = store?.getCurrentRecordId();
  if (!(store && id)) {
    throw Error('Missing wf instance store!');
  }
  const record = get<DBRow<IoWfInstances> | undefined>(
    [...store.recordsPath, id],
    undefined,
  );
  if (!record) {
    throw Error('Missing wf instance!');
  }
  return record;
}

export function validateCode(code?: string): string | null {
  if (isEmpty(code)) {
    return null;
  }
  code = code.replace(/\/\/.*|\/\*[\s\S]*?\*\//g, '');
  const wf_list = [...code.matchAll(/wf\./g)];
  let await_list = [...code.matchAll(/await wf\./g)];
  if (wf_list.length !== await_list.length) {
    return 'Missing await before wf.<function> call!';
  }
  const db_list = [...code.matchAll(/db\./g)];
  await_list = [...code.matchAll(/await db\./g)];
  if (db_list.length !== await_list.length) {
    return 'Missing await before db.<function> call!';
  }
  return null;
}

export function getUserData(user: UserSession): UserData {
  return {
    displayName: user.displayName,
    userName: user.userName,
    emailAddress: user.emailAddress,
  };
}
